import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTicket,
  faBuilding,
  faArrowRight,
  faPhone,
  faEnvelope,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';

const MyGate = () => {
  return (
    <div className="support-card">
      <Row>
        <Col>
          <div className="d-flex align-items-center mb-3">
            <FontAwesomeIcon
              icon={faBuilding}
              className="support-card-icon me-2"
            />
            <h3 className="mb-0">Facility Management</h3>
          </div>
          <p>
            AWM offers comprehensive facilities management with a dedicated
            team. A Facilities Manager oversees supervisors handling community
            maintenance, facilities, and plots. Additionally, specialized
            plumbers, electricians, and security staff ensure smooth operations
            and safety for residents.
          </p>
          <p>
            To ensure no issues are overlooked, we've established a process that
            owners and residents can follow to assist the support team.
          </p>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <div className="d-flex align-items-center mb-3">
            <FontAwesomeIcon
              icon={faTicket}
              className="support-card-icon me-2"
            />
            <h4 className="mb-0">Complaint Process</h4>
          </div>
          <p>
            To report any maintenance issues, please follow the procedure below.
          </p>

          <div className="support-step">
            <FontAwesomeIcon
              icon={faArrowRight}
              className="support-step-icon"
            />
            <strong>Step 1:</strong> Submit a ticket on{' '}
            <a
              href="https://help.mygate.in/articles/124167-how-to-raise-a-helpdesk-ticket"
              className="link-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              MyGate
            </a>
            . You can expect a response within 1 to 2 business days. We review
            MyGate tickets 2 to 3 times a week with the maintenance team.
          </div>

          <div className="support-step">
            <FontAwesomeIcon icon={faPhone} className="support-step-icon" />
            <strong>Step 2:</strong> If you don't receive a response, please
            call the Society manager between 9 AM and 5 PM, Monday to Saturday.
          </div>

          <div className="support-step">
            <FontAwesomeIcon icon={faEnvelope} className="support-step-icon" />
            <strong>Step 3:</strong> If you still don't receive a response or
            resolution, please email the address provided in the below section,
            including your contact details. An EC member will call you to
            address the issue.
          </div>

          <div className="mt-4">
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="support-step-icon"
            />
            <em>
              Note: This process was created based on suggestions from the group
              to ensure complaints are handled through a clear procedure, rather
              than through chat with EC members. Please cooperate with the
              process.
            </em>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MyGate;
